import { Link, useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { useLanguage } from '../context/LanguageContext'
import { useAuth } from '../context/AuthContext'

export default function TabNavigation() {
  const location = useLocation()
  const [scrolled, setScrolled] = useState(0)
  const { t } = useLanguage()
  const { role } = useAuth()

  const tabs = [
    { path: '/', label: t.nav.overview, exact: true },
    { path: '/users', label: t.nav.users, exact: true },
    // User management is an admin-only surface: hidden entirely for role 'user'.
    ...(role === 'admin'
      ? [{ path: '/settings/users', label: t.nav.userManagement, exact: false }]
      : []),
  ]

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY
      // Cap at 200px scroll for maximum effect
      const scrollPercentage = Math.min(scrollPosition / 200, 1)
      setScrolled(scrollPercentage)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const isActive = (tab: typeof tabs[0]) => {
    if (tab.exact) {
      return location.pathname === tab.path
    }
    return location.pathname.startsWith(tab.path)
  }

  const blurAmount = scrolled > 0 ? 'backdrop-blur-lg' : ''

  return (
    <div className="sticky top-0 z-30 py-6 flex justify-center">
      <div
        className={`relative ${blurAmount} rounded-full py-2 px-2 bg-white shadow-lg`}
      >
        <div className="flex gap-1">
            {tabs.map((tab) => (
              <Link
                key={tab.path}
                to={tab.path}
                className={`
                  py-3 px-6 font-semibold text-sm whitespace-nowrap transition-all rounded-full
                  ${
                    isActive(tab)
                      ? 'text-[#1A1A1A] bg-[#FBB300]'
                      : 'text-[#2B2F3A] hover:bg-[#E0E5EC]'
                  }
                `}
              >
                {tab.label}
              </Link>
            ))}
        </div>
      </div>
    </div>
  )
}
